
import { all, call, put, takeEvery } from 'redux-saga/effects'
import history from '../history'

import {
    clearActionType,
    clearOperationSuccess,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import {
    ERROR_CLEAR_ACTION_TYPE,
    ERROR_CREATE_ACTION_TYPE ,
    ERROR_OPERATION_SUCCESS_ACTION_TYPE
} from '../common/client/sagas/operationStatus';

import { createProject, deleteProject, getProject, setParameter } from './serverApi/project';

export const GET_PROJECT_ACTION_TYPE = createActionTypes('project/GET_PROJECT', 'Načítání projektu');
export const CREATE_PROJECT_ACTION_TYPE = createActionTypes('project/CREATE_PROJECT');
export const DELETE_PROJECT_ACTION_TYPE = createActionTypes('project/DELETE_PROJECT', 'Smazání projektu');
export const SET_PARAMETER_ACTION_TYPE = createActionTypes('project/SET_PARAMETER', 'Nastavení parametru projektu');

export const REFRESH_PROJECT_ACTION_TYPE = 'project/REFRESH_PROJECT';
export const EDIT_KATUZE_ACTION_TYPE = 'project/EDIT_KATUZE';

export default function getActions(dispatch) {
    return {
        delete: (token, id) => dispatch({
            type: DELETE_PROJECT_ACTION_TYPE.DEFAULT, token, id
        }),
        editKatuze: (token, id) => dispatch({
            type: EDIT_KATUZE_ACTION_TYPE, token, id
        }),
        loadProject: (token, id) => dispatch({
            type: GET_PROJECT_ACTION_TYPE.DEFAULT, token, id
        }),
        refresh: (token, id) => dispatch({
            type: REFRESH_PROJECT_ACTION_TYPE, token, id
        }),
        setParameter: (token, id, name, value) => dispatch({
            type: SET_PARAMETER_ACTION_TYPE.DEFAULT, token, id,
            name, value
        })
    };
}

function* workCreateProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const data = yield call(createProject, options.serverApi, action);
        yield put({type: CREATE_PROJECT_ACTION_TYPE.SUCCESS, data: data});
        yield call(history.push, `/projectview/${data.created.id}`);
    } catch (error) {
        yield put({type: CREATE_PROJECT_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workDeleteProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const data = yield call(deleteProject, options.serverApi, action);
        yield put({type: DELETE_PROJECT_ACTION_TYPE.SUCCESS, data: data});
        yield put({type: ERROR_OPERATION_SUCCESS_ACTION_TYPE, operation: DELETE_PROJECT_ACTION_TYPE.title});
        yield call(history.push, '/projectList');
        yield call(clearOperationSuccess);
    } catch (error) {
        yield put({type: DELETE_PROJECT_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workEditKatuze(options, action) {
    yield put({
        type: SET_PARAMETER_ACTION_TYPE.DEFAULT,
        token: action.token, id: action.id,
        name: 'status', value: 'DEF_KU'
    });
}

function* workGetProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const data = yield call(getProject, options.serverApi, action);
        yield put({type: GET_PROJECT_ACTION_TYPE.SUCCESS, data: data});
    } catch (error) {
        yield put({type: GET_PROJECT_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workRefreshProject(options, action) {
    try {
        const data = yield call(getProject, options.serverApi, action);
        yield put({type: GET_PROJECT_ACTION_TYPE.SUCCESS, data: data});
    } catch (error) {
        // nop;
    }
}

function* workSetParameter(options, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: SET_PARAMETER_ACTION_TYPE.title});
        const data = yield call(setParameter, options.serverApi, action);
        yield put({
            type: SET_PARAMETER_ACTION_TYPE.SUCCESS, data: data,
            name: action.name, value: action.value
        });
        yield call(checkOperationResult, data.result, {title: SET_PARAMETER_ACTION_TYPE.title});
    } catch (error) {
        yield call(setOperationError, error, SET_PARAMETER_ACTION_TYPE);
    }
}

export function* watchProject(options) {
    yield all([
        takeEvery(CREATE_PROJECT_ACTION_TYPE.DEFAULT, workCreateProject, options),
        takeEvery(DELETE_PROJECT_ACTION_TYPE.DEFAULT, workDeleteProject, options),
        takeEvery(GET_PROJECT_ACTION_TYPE.DEFAULT, workGetProject, options),
        takeEvery(EDIT_KATUZE_ACTION_TYPE, workEditKatuze, options),
        takeEvery(REFRESH_PROJECT_ACTION_TYPE, workRefreshProject, options),
        takeEvery(SET_PARAMETER_ACTION_TYPE.DEFAULT, workSetParameter, options)
    ]);
}
